export const SERVICE_CODE = 'DASHBOARD_CONSULTANT_WORKLOAD' + '_SERVICE';
